/**
 * @Copyright (c) 2022 DigiNet
 * @author TRANGHOANG
 * @create 10/1/2022
 * @Example
 */

export const types = {
    W39F3040_LOAD_FORM: 'W39F3040_LOAD_FORM',
    W39F3040_GET_GROUP_DUTY: 'W39F3040_GET_GROUP_DUTY',
    W39F3040_LOAD_TREELIST: 'W39F3040_LOAD_TREELIST',
    W39F3040_LOAD_FILTER: 'W39F3040_LOAD_FILTER',
    W39F3040_EXPORT_EXCEL: 'W39F3040_EXPORT_EXCEL'
};

export function getFormData(params, cb) {
    return {
        type: types.W39F3040_LOAD_FORM,
        params,
        cb,
    };
}

export function getCbGroupDuty(params, cb) {
    return {
        type: types.W39F3040_GET_GROUP_DUTY,
        params,
        cb,
    };
}

export function loadTreeList(params, cb) {
    return {
        type: types.W39F3040_LOAD_TREELIST,
        params,
        cb,
    };
}

export function loadFilter(params, cb) {
    return {
        type: types.W39F3040_LOAD_FILTER,
        params,
        cb,
    };
}

export function exportExcel(params, cb) {
    return {
        type: types.W39F3040_EXPORT_EXCEL,
        params,
        cb,
    };
}